/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */
module.exports = [
    // Covid
    [882, 904, 913, 884, 876, 878, 890, 877, 891, 892, 895, 896, 887, 879, 897, 910, 880, 872, 873, 886, 889, 888,
        901, 902, 903, 874, 894, 906, 875, 912, 909, 914, 868, 893, 911, 908, 900, 869, 907, 898, 899, 870, 905,
        871, 885, 881, 883],
    // Freebies
    [645, 401, 652, 212, 46, 123, 139, 640, 639, 648, 622, 624, 626, 628, 646, 630, 617, 107, 615, 417, 128, 636, 654,
        656],
    // Room Services
    [321, 320, 43, 455, 5, 826],
    // Hotel Services
    [8, 422, 111, 206, 507, 124, 53, 158, 427, 23, 508, 509, 49, 46, 619, 492, 44, 428, 515, 245, 22, 486, 91, 13, 2,
        127, 161, 300, 504, 67, 89, 78, 675, 134, 52],
    // Wellness
    [660, 667, 820, 249, 27, 11, 601, 417, 204, 79, 230, 232, 454, 138, 821, 63, 803, 103, 604, 603, 55, 104, 605, 651,
        805, 822, 10, 602, 50, 54, 496, 672, 200, 802, 418, 846, 847, 848],
    // Breakfasts, Restaurants, and Bars
    [7, 72, 301, 462, 464, 633, 102, 478, 497, 536, 305, 632, 24, 471, 485, 482, 159, 674, 475, 311, 312, 520, 473, 677,
        73, 223, 510, 467, 3, 116, 115, 241, 438, 439, 516, 117, 444, 133, 824, 441, 135, 479, 484, 844, 845],
    // Technology
    [224, 814, 107, 615, 818, 816, 670, 47, 809, 453, 166, 518, 220, 808, 810, 819, 96, 164, 163, 483, 616],
    // Mobility and Transportation
    [17, 140, 642, 641, 649, 65, 123, 75, 668, 623, 535, 468, 415, 625, 627, 139, 640, 639, 648, 622, 624, 626, 628,
        646, 630, 617, 609, 215, 461, 629, 128, 129, 611, 647, 631, 643, 503],
    // Sports and Leisure
    [487, 423, 488, 502, 472, 493, 208, 211, 146, 426, 77, 69, 404, 465, 531, 469, 235, 76, 490, 62, 314, 82, 19, 806,
        495, 12, 413, 506, 491, 70, 86, 306, 456, 447, 97, 476, 307, 501, 807, 406, 407, 114, 436, 233, 437, 480, 130,
        505, 131, 100, 99, 637, 610, 132, 26, 90, 457, 225, 87, 500, 9, 440, 494, 148, 219, 137, 474, 61, 210],
    // Entertainment
    [30, 411, 804, 499, 125, 147, 645, 59, 621, 513, 126, 470, 849, 854, 855, 858, 859, 850, 851, 852, 853, 856, 857,
        860, 861, 862],
    // General
    [149, 530, 213, 659, 650, 218, 240, 534, 514, 150, 523, 532, 537, 528, 529, 401, 644, 652, 656, 212, 654, 636, 815,
        538, 98, 60, 522, 525, 614, 153, 154, 512, 540, 539, 527, 429, 511, 246, 653, 317, 222, 145, 430, 431, 432, 433,
        434, 238, 658, 498, 635, 4, 608, 400, 214, 203, 152, 526, 620, 655, 151, 92, 448, 452, 533, 524, 155, 156, 637,
        613, 416, 867],
    // Facilities
    [109, 517, 823, 101, 226, 420, 57, 45, 813, 71, 313, 88, 110, 207, 811, 25, 28, 239, 29, 14, 80, 66, 48, 142, 221,
        606, 435, 108, 16, 676, 801, 167, 638, 51, 141, 463, 612, 64, 118, 58, 15, 812, 143, 477, 41, 817, 157, 863,
        864, 865, 866],
    // Children services
    [662, 825, 21, 309, 144, 664, 56, 202, 661, 663, 665, 481, 634, 666, 841, 842, 843],
    // Business
    [618, 20, 607, 302, 669, 671, 81, 6, 303, 521, 519],
];
